import { Charts } from './Charts';
import ValuesChartsDataProvider from './contexts/ValuesChartsDataContext';

const ValuesWrapper = () => {
    return (
        <ValuesChartsDataProvider>
            <Charts />
        </ValuesChartsDataProvider>
    );
};

export default ValuesWrapper;
